import { WorkShopDTO } from './../../shared/dto/work-shop.dto';
// import { AppConfig } from './../../config';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, HostListener } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CoreService } from '../../shared/service/app/core.service';
import { MessageChatDTO } from './../../shared/dto/message-chat.dto';
import { CommonService } from './../../shared/service/common/common.service';
import moment from 'moment';
import { AssistantService } from './service/assistant.service';
import { initialMessage } from './../../shared/constants/message.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoordinatesDTO } from './../../shared/dto/common.dto';
import { AnalitycsService } from './../../shared/service/analitycs.service';
import { NewChatDTO, NewMessageDTO } from './../../shared/dto/message-chat.dto';
import { initialNewChat } from './../../shared/constants/message.constants';
import { AuthService } from '../../shared/service/auth/auth.service';

const slideDownUp = trigger('slideDownUp', [
  state('void', style({ opacity: 0, transform: 'translateY(-20px)' })),
  state('*', style({ opacity: 1, transform: 'translateY(0)' })),
  transition('void => *', animate('200ms ease-in')),
  transition('* => void', animate('200ms ease-out')),
]);

@Component({
  selector: 'app-assistant',
  templateUrl: './assistant.component.html',
  styleUrls: ['./assistant.component.css'],
  animations: [slideDownUp],
})
export class AssistantComponent implements OnInit {
  @ViewChild('scrollable') scrollable!: NgScrollbar;
  @Input() selectedService: string = '';

  currentDate: string = moment().format('YYYY-MM-DD');
  isMobile: boolean = false;
  coordinates: CoordinatesDTO = { lat: 0, lng: 0 };
  isMapVisible: boolean = false;
  isSmallScreen: boolean = false;
  chatExpandido: boolean = false;
  textMessage: string = '';
  loadingConversation: boolean = false;
  messages: MessageChatDTO[] = [];
  chatId: string = '';
  myIp: string = '';
  message: MessageChatDTO | undefined;
  ip: string = '';
  workShop: WorkShopDTO | null = null;
  isAssistantVisible: boolean = false;
  workshopsFromAssistant: WorkShopDTO[] = [];
  isDarkMode: boolean = false;
  isAuthenticated: boolean = false;

  // Objeto para almacenar datos del chat actual
  currentChat: NewChatDTO | null = null;

  constructor(
    public store: Store<any>,
    public core: CoreService,
    public commonService: CommonService,
    private router: Router,
    private assistantService: AssistantService,
    private route: ActivatedRoute,
    private analitycs: AnalitycsService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
  ) {
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }

    // Suscripción al tema
    this.store
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }

  ngOnInit(): void {
    // Verificar si el usuario ya tiene un token
    const token = localStorage.getItem('secTkn');
    if (token) {
      console.log('El usuario ya tiene un token, se actualiza el estado de autenticación');
      this.isAuthenticated = true;
      this.authService.setAuthenticated(true);
    }

    this.onResize();
    this.route.queryParams.subscribe((params) => {
      this.selectedService = params['service'];
    });
    this.route.queryParams.subscribe((params) => {
      const lat = Number(params['lat']);
      const lng = Number(params['lng']);

      if (!isNaN(lat) && !isNaN(lng)) {
        this.coordinates = { lat, lng };
      }
    });
    this.checkScreenSize();
    this.startConversation(0);
  }

  checkScreenSize(): void {
    const width = localStorage.getItem('screenWidth') ?? 0;
    this.isSmallScreen = Number(width) <= 900;
    // console.log('isSmallScreen:', this.isSmallScreen, width);
  }

  toggleMap() {
    this.analitycs.logEvent('mapa_asistente', {
      pantalla: 'assistant',
      accion: 'clic',
      detalle: 'alternar_mapa',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.isMapVisible = !this.isMapVisible;
  }
  // Método principal para iniciar conversación (ahora usa la nueva implementación)
  async startConversation(id: number) {
    this.loadingConversation = true;

    // Si el usuario está autenticado, modificamos el mensaje inicial
    if (this.isAuthenticated) {
      console.log('Usuario autenticado, personalizando mensajes iniciales');
    }

    this.analitycs.logEvent('inicio_conversacion_asistente_ai', {
      pantalla: 'assistant',
      accion: 'clic',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.loadingConversation = true;
    try {
      // Eliminar datos antiguos si existen
      localStorage.removeItem('sender');
      localStorage.removeItem('chat');

      const chatData = id === 0 ? localStorage.getItem('newChat') : null;
      this.ip = await this.commonService.getIPAddress();

      if (chatData) {
        const savedChat = JSON.parse(chatData);
        this.chatId = savedChat.id;
        this.currentChat = savedChat;
        if (savedChat.messages && savedChat.messages.length > 0) {
          this.messages = []; // Limpiamos los mensajes antiguos
          // Convertimos los mensajes al formato que espera la UI
          savedChat.messages.forEach((msg: NewMessageDTO) => {
            const uiMessage: MessageChatDTO = JSON.parse(JSON.stringify(initialMessage));
            uiMessage.role = msg.role;
            uiMessage.content[0].text.value = msg.content;
            this.messages.push(uiMessage);
          });
        }
      } else {
        this.messages = [];
        // Creamos una nueva conversación
        const newChat = this.buildNewChat();
        if (this.selectedService !== '' && this.selectedService !== undefined) {
          newChat.initial_message.content = `Necesito un Servicio de ${this.selectedService}`;
        }

        const response = await this.assistantService.createNewChat(newChat);
        this.chatId = response.id || '';
        this.currentChat = response;

        // Guardamos la respuesta en localStorage
        localStorage.setItem('newChat', JSON.stringify(response));

        // Convertimos los mensajes al formato que espera la UI
        if (response.messages && response.messages.length > 0) {
          this.messages = []; // Limpiamos los mensajes antiguos
          response.messages.forEach((msg: NewMessageDTO) => {
            const uiMessage: MessageChatDTO = JSON.parse(JSON.stringify(initialMessage));
            uiMessage.role = msg.role;
            uiMessage.content[0].text.value = msg.content;
            this.messages.push(uiMessage);
          });
        }
      }
    } catch (error: any) {
      console.error('Error starting conversation:', error);
      const errorMessage: MessageChatDTO = JSON.parse(JSON.stringify(initialMessage));
      errorMessage.role = 'assistant';
      errorMessage.content[0].text.value = 'Existe un error al contactar con el asistente, por favor intentelo de nuevo mas tarde.';
      this.messages.push(errorMessage);
    }
    this.loadingConversation = false;
    this.scrollToBottom();
  }

  // Método para construir el chat con la nueva estructura
  buildNewChat(message: string = ''): NewChatDTO {
    const newChat: NewChatDTO = JSON.parse(JSON.stringify(initialNewChat));
    newChat.user_id = this.ip;
    newChat.initial_message.content = message || '';

    // Inicializar metadatos
    if (!newChat.initial_message.metadata) {
      newChat.initial_message.metadata = {};
    }

    if (!newChat.metadata) {
      newChat.metadata = {};
    }

    // Asegurar que se inicialicen los metadatos básicos
    if (newChat.initial_message.metadata) {
      newChat.initial_message.metadata.source = 'fe-web';
      newChat.initial_message.metadata.userAgent = navigator.userAgent;
      newChat.initial_message.metadata.ip = this.ip;
    }

    // Si tenemos coordenadas, las añadimos
    if (this.coordinates && this.coordinates.lat !== 0 && this.coordinates.lng !== 0 && newChat.metadata) {
      if (!newChat.metadata.gpsLocation) {
        newChat.metadata.gpsLocation = {
          type: 'Point',
          coordinates: [],
        };
      }
      newChat.metadata.gpsLocation.coordinates = [this.coordinates.lng, this.coordinates.lat];
    }

    // Si el usuario está autenticado, añadimos información al contexto
    if (this.isAuthenticated) {
      console.log('Construyendo nuevo chat con usuario autenticado');

      // Obtener información del usuario desde el localStorage
      const sessionData = localStorage.getItem('session');
      if (sessionData) {
        try {
          const userSession = JSON.parse(sessionData);
          console.log('Datos de sesión del usuario para nuevo chat:', userSession);

          // Crear objeto con la información del usuario
          const userInfo = {
            isAuthenticated: true,
            userId: userSession.idClient,
            userEmail: userSession.email,
            userName: userSession.name + ' ' + (userSession.lastname || ''),
            userPhone: userSession.phone,
          };

          // Crear objeto con metadatos completos
          const metadataObj = {
            ...userInfo,
            source: 'fe-web',
            userAgent: navigator.userAgent,
            ip: this.ip,
            // Añadir también en formato userInfo para compatibilidad
            userInfo: {
              ...userInfo,
            },
          };

          // Añadir información a los metadatos del chat
          if (newChat.metadata) {
            newChat.metadata = {
              ...newChat.metadata,
              ...metadataObj,
            };
          }

          // Añadir información también a los metadatos del mensaje inicial
          if (newChat.initial_message.metadata) {
            newChat.initial_message.metadata = {
              ...newChat.initial_message.metadata,
              ...metadataObj,
            };
          }

          // Añadir token para verificación en backend
          const token = localStorage.getItem('secTkn');

          // Asegurar que los metadatos estén inicializados correctamente
          if (!newChat.metadata) {
            newChat.metadata = {};
          }

          if (token) {
            // Asegurar que el token esté presente en varios lugares para mayor compatibilidad
            if (newChat.metadata) {
              newChat.metadata.token = token;
              // Usar aserción de tipo para evitar errores de TypeScript
              (newChat.metadata as any)['secTkn'] = token;

              // Forzar la bandera de autenticación
              newChat.metadata.isAuthenticated = true;
            }

            // Asegurar que también esté en los metadatos del mensaje inicial
            if (newChat.initial_message && newChat.initial_message.metadata) {
              newChat.initial_message.metadata.token = token;
              // Usar aserción de tipo para evitar errores de TypeScript
              (newChat.initial_message.metadata as any)['secTkn'] = token;
              newChat.initial_message.metadata.isAuthenticated = true;
            }

            console.log('Token enviado en los metadatos del nuevo chat:', token);
          }
        } catch (error) {
          console.error('Error al procesar datos de sesión', error);
        }
      } else {
        console.log('Usuario autenticado pero no se encontraron datos de sesión');
      }
    }

    return newChat;
  }

  // Método para enviar mensajes con la nueva API
  async sendMessage() {
    if (this.textMessage.trim() === '') return;

    try {
      this.loadingConversation = true;
      // Modificar respuestas según el estado de autenticación
      const isAppointmentMessage = this.textMessage.toLowerCase().includes('cita');

      if (isAppointmentMessage && this.isAuthenticated) {
        // Si es un mensaje relacionado con citas y el usuario está autenticado
        // No pediremos datos personales que ya tenemos
        console.log('Usuario autenticado solicitando cita, no pediremos datos personales');
      }

      // Creamos un mensaje temporal para la UI
      const tempMessage: MessageChatDTO = JSON.parse(JSON.stringify(initialMessage));
      tempMessage.role = 'user';

      // Si es un mensaje para agendar cita, lo formateamos para la UI
      if (this.textMessage.includes('Quiero agendar una cita') && this.workShop) {
        tempMessage.content[0].text.value = this.formatAppointmentMessage(this.textMessage, this.workShop.companyName);
      } else {
        tempMessage.content[0].text.value = this.textMessage;
      }

      this.messages.push(tempMessage);

      // Preparamos el mensaje para enviar
      const messageToSend: NewMessageDTO = {
        content: this.textMessage,
        role: 'user',
        conversation_id: this.chatId,
        metadata: {
          source: 'fe-web',
          userAgent: navigator.userAgent,
          ip: this.ip,
        },
      };

      // Añadir información de autenticación si el usuario está autenticado
      if (this.isAuthenticated) {
        // Obtener información del usuario desde el localStorage
        const sessionData = localStorage.getItem('session');
        if (sessionData) {
          try {
            const userSession = JSON.parse(sessionData);
            console.log('Enviando datos de autenticación al asistente:', userSession);

            // Crear objeto con la información del usuario
            const userInfo = {
              isAuthenticated: true,
              userId: userSession.idClient,
              userEmail: userSession.email,
              userName: userSession.name + ' ' + (userSession.lastname || ''),
              userPhone: userSession.phone,
            };

            // Asegurarse de que metadata esté inicializado
            if (!messageToSend.metadata) {
              messageToSend.metadata = {
                source: 'fe-web',
                userAgent: navigator.userAgent,
                ip: this.ip,
              };
            }

            // Añadir información del usuario a los metadatos
            if (messageToSend.metadata) {
              // Añadir campos individuales
              messageToSend.metadata.isAuthenticated = true;
              messageToSend.metadata.userId = userSession.idClient;
              messageToSend.metadata.userEmail = userSession.email;
              messageToSend.metadata.userName = userSession.name + ' ' + (userSession.lastname || '');
              messageToSend.metadata.userPhone = userSession.phone;

              // Añadir también en formato userInfo para compatibilidad
              messageToSend.metadata.userInfo = { ...userInfo };

              // Añadir token para verificación en backend - ASEGURAR que se envía siempre
              const token = localStorage.getItem('secTkn');
              if (token) {
                // Asegurar que el token esté presente en varios lugares para mayor compatibilidad
                messageToSend.metadata.token = token;

                // Añadir secTkn de forma segura
                try {
                  messageToSend.metadata['secTkn'] = token; // Intentar acceso directo primero
                } catch {
                  // Si falla, usar aserción de tipo
                  (messageToSend.metadata as any)['secTkn'] = token;
                }

                // Forzar la bandera de autenticación
                messageToSend.metadata.isAuthenticated = true;

                console.log('Token enviado en los metadatos:', token);
              }
            }
          } catch (error) {
            console.error('Error al procesar datos de sesión', error);
          }
        }
      }

      // Añadimos información adicional si es necesario
      if (isAppointmentMessage && this.workShop) {
        messageToSend.content += ` (Ten en cuenta el workShopName=${this.workShop?.companyName}, workShopId=${this.workShop?._id}, workShopTuulAppId=${this.workShop?.idTuulapp})`;
      }

      // Guardamos el mensaje y limpiamos el input
      this.textMessage = '';

      // Enviamos el mensaje al servidor
      const response = await this.assistantService.sendNewMessage(messageToSend);

      // Procesamos la respuesta
      this.processResponse(response);

      // Actualizamos localStorage
      localStorage.setItem('newChat', JSON.stringify(response));
    } catch (error) {
      console.error('Error sending message:', error);
      const errorMessage: MessageChatDTO = JSON.parse(JSON.stringify(initialMessage));
      errorMessage.role = 'assistant';
      errorMessage.content[0].text.value = 'Existe un error al contactar con el asistente, por favor intentelo de nuevo mas tarde.';
      this.messages.push(errorMessage);
    }
    this.loadingConversation = false;
  }

  // Método para procesar la respuesta del servidor
  processResponse(response: any) {
    console.log('Procesando respuesta del asistente:', response);

    // Verificar si hay mensajes en la respuesta
    if (response.messages && response.messages.length > 0) {
      // Procesar cada mensaje del asistente
      response.messages.forEach((msg: any) => {
        if (msg.role === 'assistant') {
          // Crear un mensaje para la UI
          const assistantMessage: MessageChatDTO = JSON.parse(JSON.stringify(initialMessage));
          assistantMessage.role = 'assistant';

          // Si el usuario está autenticado, modificar mensajes específicos
          if (this.isAuthenticated && typeof msg.content === 'string') {
            // Caso 1: Mensaje de iniciar sesión para ver cita
            if (msg.content.includes('Inicia sesión para ver tu cita')) {
              console.log('Modificando mensaje de iniciar sesión');
              msg.content = msg.content.replace(
                'Inicia sesión para ver tu cita. Estoy a la orden si necesitas más ayuda.',
                'Puedes ver los detalles de tu cita en tu perfil. Estoy a la orden si necesitas más ayuda.',
              );
            }

            // Caso 2: Mensaje pidiendo datos personales
            if (msg.content.includes('propórcioname los siguientes datos')) {
              console.log('Modificando mensaje de solicitud de datos');

              // Obtener datos del usuario
              const sessionData = localStorage.getItem('session');
              if (sessionData) {
                try {
                  const userSession = JSON.parse(sessionData);
                  const userName = userSession.name + ' ' + (userSession.lastname || '');
                  const userEmail = userSession.email || '';
                  const userPhone = userSession.phone || '';

                  // Crear un mensaje personalizado
                  msg.content =
                    `Veo que ya tienes una cuenta con nosotros. Usaré tus datos registrados:\n\n` +
                    `- Nombre: ${userName}\n` +
                    `- Email: ${userEmail}\n` +
                    `- Teléfono: ${userPhone}\n\n` +
                    `Solo necesito que me proporciones los datos de tu vehículo:\n\n` +
                    `1. Placa del vehículo\n` +
                    `2. Marca del vehículo\n` +
                    `3. Modelo del vehículo\n` +
                    `4. Año del vehículo`;
                } catch (error) {
                  console.error('Error al procesar datos de sesión', error);
                }
              }
            }
          }

          // Asignar el contenido al mensaje
          assistantMessage.content[0].text.value = msg.content;

          // Agregar mensaje a la conversación
          this.messages.push(assistantMessage);
        }
      });

      // Desplazar al final de la conversación
      this.scrollToBottom();
    } else if (response.message) {
      // Compatibilidad con el formato antiguo de respuesta
      // Modificar el mensaje si contiene "Inicia sesión para ver tu cita" y el usuario ya está autenticado
      if (
        this.isAuthenticated &&
        response.message.content &&
        typeof response.message.content === 'string' &&
        response.message.content.includes('Inicia sesión para ver tu cita')
      ) {
        // Reemplazar el texto de iniciar sesión por un mensaje más apropiado
        response.message.content = response.message.content.replace(
          'Inicia sesión para ver tu cita. Estoy a la orden si necesitas más ayuda.',
          'Puedes ver los detalles de tu cita en tu perfil. Estoy a la orden si necesitas más ayuda.',
        );
      }

      // Agregar mensaje a la conversación
      this.messages.push(response.message);
      this.scrollToBottom();
    }
  }

  scrollToBottom(): void {
    setTimeout(() => {
      try {
        this.scrollable.scrollTo({ bottom: 0, duration: 200 });
      } catch (error) {
        throw error;
      }
    }, 300);
  }

  assistantSchedule(workShop: WorkShopDTO | null) {
    this.analitycs.logEvent('agendar_cita_taller', {
      pantalla: 'assistant',
      accion: 'click',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    // Asegurarse de que el asistente esté visible
    if (!this.isAssistantVisible) {
      this.toggleAssistant();
    }

    // Establecer el workshop seleccionado
    this.workShop = workShop!;

    // // Si está en pantalla pequeña, ocultar el mapa
    // if (this.isSmallScreen) {
    //   this.toggleMap();
    // }

    // this.core.toggleToMap(false);

    // Forzar la detección de cambios para asegurar que el componente hijo reciba el valor actualizado
    this.cdr.detectChanges();
  }

  assistantSearchWorkshop(workshops: WorkShopDTO[]) {
    this.analitycs.logEvent('buscar_taller', {
      pantalla: 'assistant',
      accion: 'click',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    // Procesar los talleres encontrados
    if (workshops && workshops.length > 0) {
      this.workshopsFromAssistant = workshops;
    }
  }

  //   backToHome() {
  //     this.analitycs.logEvent('volver_a_home', {
  //       pantalla: 'assistant',
  //       accion: 'click',
  //       plataforma: 'web',
  //       timestamp: new Date().toISOString(),
  //     });
  //     if (this.coordinates.lat === 0 && this.coordinates.lng === 0) {
  //       this.router.navigate(['']);
  //     } else {
  //       this.router.navigate([''], { queryParams: { lat: this.coordinates.lat, lng: this.coordinates.lng } });
  //     }
  //   }

  toggleAssistant() {
    this.analitycs.logEvent('abrir_assistant', {
      pantalla: 'assistant',
      accion: 'click',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.isAssistantVisible = !this.isAssistantVisible;
    // console.log('Estado del Assistant:', this.isAssistantVisible);
    this.cdr.detectChanges(); // Forzar actualización en la UI
  }

  // Detectar tamaño de pantalla para ajustes responsivos
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isSmallScreen = window.innerWidth < 768;
  }

  // Método para recibir los talleres del componente hijo (app-assistant-ai)
  receiveWorkshops(workshops: WorkShopDTO[]) {
    this.analitycs.logEvent('talleres_recibidos_del_assistant', {
      pantalla: 'assistant',
      accion: 'actualizar',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    // console.log('Talleres recibidos en Assistant Component:', workshops);
    this.workshopsFromAssistant = workshops;
    // Detectar cambios para asegurar que la actualización se refleja en la vista
    this.cdr.detectChanges();
  }

  // Método que se ejecuta cuando los talleres son actualizados en el mapa
  onWorkshopsUpdated() {
    this.analitycs.logEvent('talleres_actualizados_en_el_mapa', {
      pantalla: 'assistant',
      accion: 'actualizar',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    // console.log('Talleres actualizados en el mapa');
    this.workshopsFromAssistant = [];
  }
  alternarChat() {
    this.analitycs.logEvent('alternar_chat', {
      pantalla: 'assistant',
      accion: 'clic',
      detalle: 'alternar_chat',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.chatExpandido = !this.chatExpandido;
  }

  /**
   * Formatea el mensaje de agendar cita para que se vea mejor en la interfaz de usuario
   * @param message El mensaje original
   * @param workshopName El nombre del taller
   * @returns El mensaje formateado para mostrar en la UI
   */
  formatAppointmentMessage(message: string, workshopName: string): string {
    // Truncamos completamente el mensaje y solo mostramos la parte esencial
    return `Quiero agendar una cita en <strong>${workshopName}</strong>`;
  }
}
